module.exports = __webpack_public_path__ + "static/1-min-77fbc39a16dce7750be29edd9cf595f8.jpg";